// components/Tasks/KanbanColumn.tsx
import React from 'react';
import { useDroppable } from '@dnd-kit/core';

interface KanbanColumnProps {
  id: string; // The ID of the droppable area (e.g., 'backlog', or a sprint ID)
  children: React.ReactNode;
  className?: string;
}

/**
 * A generic, reusable wrapper that makes any content a droppable column
 * in a Kanban board.
 */
export const KanbanColumn: React.FC<KanbanColumnProps> = ({ id, children, className }) => {
  const { setNodeRef } = useDroppable({ id });

  return (
    <div ref={setNodeRef} className={className}>
      {children}
    </div>
  );
};